<template>
  <div class="price">
    <span class="price-unit" v-if="currency_name === '￥'">￥</span>
    <span class="price-coupon">{{ parseInt(price) }}</span>
    <span class="price-unit" v-if="currency_name !== '￥'">
      <span class="currency-name" v-if="currency_name.length <= 1">
        {{ currency_name }}
      </span>
      <div class="currency-name" v-else>
        {{ currency_name }}
      </div>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    price: Number | String
  },
  data() {
    return {
      currency_rate: 1,
      currency_name: "元"
    };
  },
  mounted() {
    this.currency_rate = localStorage.getItem("currency_rate") || 1;
    this.currency_name = localStorage.getItem("currency_name") || "元";
    if (
      this.currency_name === "undefined" ||
      this.currency_name === "rmb" ||
      this.currency_name === "元"
    ) {
      this.currency_name = "￥";
    }
  }
};
</script>
<style lang="less" scoped>
.price {
  color: #ff482c;
  font-weight: bold;
  text-align: center;
  font-size: 13px;

  .price-coupon {
    font-size: 32px;
    line-height: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coupon-list/price.vue